import React from 'react'
import { useTranslation } from 'react-i18next'
import Banner from '../components/Banner';
import Section1 from '../components/production/Section1';
import Section2 from '../components/production/Section2';

const Uretim = () => {
    const { t } = useTranslation();

    const bannerData = {
        title: t("production.title"),
        img: "/images/about/about2.jpg",
    };
    return (
        <div>
            <div className="grid grid-cols-10 pb-28">
                <div className="col-start-2 md:col-start-2 col-span-8 ">
                    <Banner bannerData={bannerData} />

                    <Section1 />

                    <Section2 />

                </div>
            </div>
        </div>
    )
}

export default Uretim
